/**
 * This submodule is a UI handler for the PLP
 * --- Purpose ---
 * Display/Remove errors
 * Enable/Disable buttons
 * Shift buttons on state change
 */
 define([], function() {
    const addToCartUIHandling = {

        /**
         * Shows an error
         * --- Example ---
         * const formObject = $('myForm')
         * const errorMessage = 'Some error message'
         * showError(formObject, errorMessage)
         * @param {Object} formObject
         * @param {String} errorMessage
         */
        showError: function(formObject, errorMessage) {
            const errorContainer = $(formObject).find('.span-error:first');
            const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
            inputField.addClass('error');
            errorContainer.html(errorMessage.replace(/&lt;/g, '<').replace(/&gt;/g, '>')).show();
        },

        /**
         * Hides the error
         * Pass the formObject only
         * See example above for passing form objects
         * @param {Object} formObject
         */
        hideError: function(formObject) {
            const errorContainer = $(formObject).find('.span-error:first');
            const inputField = formObject.find('.product-quick-buy-txt .form-control');
            inputField.removeClass('error');
            errorContainer.html('').hide();
        },

        /**
         * Displays the message "XXX in cart"
         * @param {Object} formObject
         * @param {String} message
         */
        showAddedToCartMessage: function(formObject, message) {
            const itemInCartContainer = $(formObject).find('.item-in-cart');
            const itemInCartMessage = $(formObject).find('#In-Cart').val();
            itemInCartContainer.html(message + ' ' + itemInCartMessage).show();
        },

        /**
         * Hides the in-cart message
         * @param {Object} formObject
         */
        hideAddedToCartMessage: function(formObject) {
            const itemInCartContainer = $(formObject).find('.item-in-cart');
            itemInCartContainer.hide();
        },

        /**
         * Disables the add to cart button
         * pass the form as an object
         * --- Example ---
         * const formObject = $('myForm')
         * disableAddToCartButton(formObject)
         * @param {Object} formObject
         */
        disableAddToCartButton: function(formObject) {
            const addToCartButton = $(formObject).find('.product-quick-buy-btn button');
            addToCartButton.addClass('disabled');
        },

        /**
         * Enables the add to cart button
         * --- Example ---
         * const formObject = $('myForm')
         * enableAddToCartButton(formObject)
         * @param {Object} formObject
         */
        enableAddToCartButton: function(formObject) {
            const addToCartButton = $(formObject).find('.product-quick-buy-btn button');
            addToCartButton.removeClass('disabled');
        },

        /**
         * Hides the div that wraps
         * the add to cart button
         * @param {Object} formObject
         */
        hideAddToCartButtonWrapper: function(formObject) {
            const addToCartButtonWrapper = $(formObject).find('.product-quick-buy-btn');
            addToCartButtonWrapper.hide();
        },

        /**
         * Disables the minQtyBtn
         * @param {Object} formObject
         */
        disableMinQtyButton: function(formObject) {
            const minQtyBtn = $(formObject).find('button[data-type=minus]');
            minQtyBtn.addClass('disabled');
        },

        /**
         * Enables the minQtyBtn
         * @param {Object} formObject
         */
        enableMinQtyButton: function(formObject) {
            const minQtyBtn = $(formObject).find('button[data-type=minus]');
            minQtyBtn.removeClass('disabled');
        },

        /**
         * Disables the maxQtyBtn
         * @param {Object} formObject
         */
        disableMaxQtyButton: function(formObject) {
            const maxQtyBtn = $(formObject).find('button[data-type=plus]');
            maxQtyBtn.addClass('disabled');
        },

        /**
         * Enables the maxQtyBtn
         * @param {Object} formObject
         */
        enableMaxQtyButton: function(formObject) {
            const maxQtyBtn = $(formObject).find('button[data-type=plus]');
            maxQtyBtn.removeClass('disabled');
        },

        /**
         * Disables the quantity input field
         * @param {Object} formObject
         */
        disableInputField: function(formObject) {
            const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
            inputField.attr('readonly', 'true');
        },

        /**
         * Enables the quantity input field
         * @param {Object} formObject
         */
        enableInputField: function(formObject) {
            const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
            inputField.removeAttr('readonly');
        },

        /**
         * Enlarges the div wrapping the input field
         * Primary use: item added to cart
         * @param {Object} formObject
         */
        enlargeInputFieldWrapper: function(formObject) {
            const divWrapper = $(formObject).find('.product-quick-buy-txt');
            divWrapper.addClass('product-in-cart');
        },

        /**
         * Disables all buttons and the input field
         * @param {Object} formObject
         */
        disableAll: function(formObject) {
            this.disableAddToCartButton(formObject);
            this.disableMaxQtyButton(formObject);
            this.disableMinQtyButton(formObject);
            this.disableInputField(formObject);
        },

        /**
         * Enables all buttons and the input field
         * @param {Object} formObject
         */
        enableAll: function(formObject) {
            this.enableAddToCartButton(formObject);
            this.enableMaxQtyButton(formObject);
            this.enableMinQtyButton(formObject);
            this.enableInputField(formObject);
        },

        /**
         * Switches the UI to the added to cart view 
         * 1 - sets the quantity in the input field
         * 2 - hides the add to cart button 
         * 3 - applies the proper class to stretch the input field
         * 4 - disables the input field
         * @param {Object} formObject
         * @param {Object} message
         */
        switchToAddedToCartView: function(formObject, message) {
            this.setInputFieldValue(formObject, message);
            this.hideAddToCartButtonWrapper(formObject);
            this.enlargeInputFieldWrapper(formObject);
            this.disableInputField(formObject);
        },

        /**
         * Sets the input field quantity value
         * @param {Object} formObject 
         * @param {String} message 
         */
        setInputFieldValue: function(formObject, message){
            const inputField = $(formObject).find('.product-quick-buy-txt .form-control');
            inputField[0].value = message;
        },
    };
    return addToCartUIHandling;
});



// WEBPACK FOOTER //
// ./js/search/addToCartUIHandling.js